import FVector from '@data/geometry/FVector';
import type { AddBuildingOp, BuildingSource, PreProcessingTypes } from '@visualizer/types';
import { buildExtrudedBuildingGroups } from './BuildExtrudedBuildinGroups';
import type { GeoEditManager } from './GeoEditManager';

type GroupTypes = {
    floor: PreProcessingTypes;
    roof: PreProcessingTypes;
    wall: PreProcessingTypes;
};

export function addExtrudedBuildingFromPolygon(args: {
    editManager: GeoEditManager;
    points: FVector[];
    height: number;
    elevation: number;
    flatTop: boolean;
    source: BuildingSource;
    groupTypes?: GroupTypes;
}) {
    const { editManager, points, height, elevation, flatTop, source, groupTypes } = args;
    const id = editManager.allocateTempId();

    const zByXY = new Map<string, number>();
    for (const p of points) zByXY.set(`${p.x},${p.y}`, p.z ?? 0);

    const groups = buildExtrudedBuildingGroups({
        polygonXY: points.map((p) => ({ x: p.x, y: p.y })),
        getTerrainZ: (x, y) => zByXY.get(`${x},${y}`) ?? 0,
        height,
        elevation,
        topMode: flatTop ? 'FLAT_FROM_LOWEST' : 'FOLLOWS_TERRAIN',
        id,
        source,
        groupTypes,
    });

    const op: AddBuildingOp = {
        command: 'ADD',
        dataType: 'building',
        source,
        id,
        groups,
    };

    editManager.apply(op);
}
